import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  Brand,
  BrandWrapper,
  ExpandIcon,
  NavIcon,
  NavPart,
  NavStyle,
  NavSubLink,
  NavSubStyle,
  NavSubTitle,
  NavTitle,
  NavWrapper,
} from "./style";
import Logo from "../../assets/svgs/logo";
import {
  TbDeviceDesktopAnalytics,
  TbPlus,
  TbMinus,
  TbUserCircle,
  TbReport,
  TbSettings,
  TbUsers,
  TbBuildingCommunity,
  TbMessage2Dollar,
  TbListDetails,
} from "react-icons/tb";
import { theme } from "../../theme";
import Ripple from "../../ppui/ripple";

// Utility to check if any path in the links is active
const isActiveGroup = (location, paths) => {
  return paths.some((path) => location.pathname.startsWith(path));
};

const NavItem = ({ title, icon, to, links = [], isNavActive }) => {
  const location = useLocation();
  const paths = links.map((link) => link.to);
  const parentIsActive = isActiveGroup(location, paths);

  const [isExpanded, setIsExpanded] = useState(parentIsActive);
  const [height, setHeight] = useState("0");
  const contentRef = useRef(null);

  const toggleExpanded = () => {
    if (contentRef.current) {
      setIsExpanded(!isExpanded);
      setHeight(
        isExpanded ? "0" : `${contentRef.current.scrollHeight / 16}rem`
      );
    }
  };

  useEffect(() => {
    if (parentIsActive && contentRef.current) {
      setHeight(`${contentRef.current.scrollHeight}px`);
      setIsExpanded(true);
    }
    if (isNavActive === true && contentRef.current) {
      setHeight(`0`);
      setIsExpanded(false);
    }
  }, [parentIsActive, isNavActive]);

  return (
    <li className={isExpanded ? "active" : ""}>
      <>
        <NavTitle
          component={links.length > 0 && "div"}
          aria-expanded={isExpanded}
          onClick={() => {
            if (links.length > 0) {
              toggleExpanded();
            }
          }}
          to={to}
          className={parentIsActive ? "active" : ""}
        >
          <NavIcon>{icon}</NavIcon>
          {!isNavActive && (
            <>
              {title}
              {links.length > 0 && (
                <ExpandIcon>{isExpanded ? <TbMinus /> : <TbPlus />}</ExpandIcon>
              )}
            </>
          )}
          <Ripple color={theme.colors.default.main} duration={1000} />
        </NavTitle>
        {links.length > 0 && (
          <NavSubStyle
            ref={contentRef}
            sx={{
              maxHeight: height,
            }}
            className={isNavActive && "collapseNav"}
          >
            {isNavActive && <NavSubTitle>{title}</NavSubTitle>}
            <ul>
              {links.map((link) => (
                <li key={link.to}>
                  <NavSubLink to={link.to}>{link.label}</NavSubLink>
                </li>
              ))}
            </ul>
          </NavSubStyle>
        )}
      </>
    </li>
  );
};

function AdminNav({ isNavActive }) {
  return (
    <>
      <NavWrapper className={isNavActive ? "navCollapse" : ""}>
        <BrandWrapper>
          <Brand to={"/"}>
            <Logo />
          </Brand>
        </BrandWrapper>
        <NavPart className={isNavActive ? "navCollapse" : ""}>
          <NavStyle>
            {/* Dashboard */}
            <NavItem
              icon={<TbDeviceDesktopAnalytics />}
              title="Dashboard"
              to="/admin"
              isNavActive={isNavActive}
            />

            {/* User */}
            <NavItem
              icon={<TbUserCircle />}
              title="User"
              to="/user"
              isNavActive={isNavActive}
            />

            {/* Organization List */}
            <NavItem
              icon={<TbBuildingCommunity />}
              title="Organization Grid"
              to="/admin/organization-list"
              isNavActive={isNavActive}
            />

            {/* Organization Table */}
            <NavItem
              icon={<TbBuildingCommunity />}
              title="Organization List"
              to="/admin/organization-table"
              isNavActive={isNavActive}
            />

            {/* Agent List */}
            <NavItem
              icon={<TbUsers />}
              title="Agent List"
              to="/agent"
              isNavActive={isNavActive}
            />

            {/* Role Permission */}
            <NavItem
              icon={<TbListDetails />}
              title="Role Permission"
              to="/rolepermission"
              isNavActive={isNavActive}
            />

            {/* Pricing */}
            <NavItem
              icon={<TbMessage2Dollar />}
              title="Pricing"
              to="/pricing"
              isNavActive={isNavActive}
            />

            {/* Report */}
            <NavItem
              icon={<TbReport />}
              title="Report"
              to="/report"
              isNavActive={isNavActive}
            />

            {/* Settings */}
            <NavItem
              icon={<TbSettings />}
              title="Settings"
              to="/admin/settings"
              isNavActive={isNavActive}
            />
          </NavStyle>
        </NavPart>
      </NavWrapper>
    </>
  );
}

export default AdminNav;
